import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ConfettiExplosion from 'react-confetti-explosion';

const IntakeProgress = ({ currentQuestion, totalQuestions, customMessage, showConfetti }) => {
  const TOTAL_CARROTS = 4;
  const progressPercentage = (currentQuestion / totalQuestions) * 100;
  // Only fill all carrots when on the final step
  const filledCarrots =
    currentQuestion >= totalQuestions
      ? TOTAL_CARROTS
      : Math.min(Math.ceil((currentQuestion / totalQuestions) * TOTAL_CARROTS), TOTAL_CARROTS - 1);
  const [isExploding, setIsExploding] = useState(false);

  useEffect(() => {
    if (showConfetti) {
      setIsExploding(true);
    }
  }, [showConfetti]);

  return (
    <div className="intake-progress">
      {isExploding && (
        <div style={{ position: 'fixed', top: 0, left: '50%', zIndex: 9999 }}>
          <ConfettiExplosion
            onComplete={() => {
              setIsExploding(false);
            }}
          />
        </div>
      )}
      <div className="intake-progress-text">{customMessage || `Question ${currentQuestion}/${totalQuestions}`}</div>
      <div className="intake-progress-carrots">
        {Array.from({ length: TOTAL_CARROTS }).map((_, index) => (
          <img
            key={index}
            src="https://cdn.foodrevolution.org/wlc/social/carrot.png"
            alt={`Progress ${index + 1}`}
            className="intake-progress-carrot"
            style={{ opacity: filledCarrots > index ? 1 : 0.2 }}
          />
        ))}
      </div>
    </div>
  );
};

IntakeProgress.propTypes = {
  currentQuestion: PropTypes.number.isRequired,
  totalQuestions: PropTypes.number.isRequired,
  customMessage: PropTypes.string,
  showConfetti: PropTypes.bool
};

export default IntakeProgress;
